import React from "react";
import { useMemo, useCallback } from "react";

import {
  IActiveLearningAnswers,
  IActiveLearningIssue,
} from "../../../../state";
import { Context, updateActiveLearningAnswers } from "../../../../studentStore";
import Button from "../../../../atoms/ActiveLearning/Button";
import Header from "../../../../organisms/ActiveLearning/Header";
import EndLesson from "../../../../organisms/ActiveLearning/EndLesson";
import Issue1 from "../../../../organisms/student/ActiveLearningLessons/Lesson10/Issue1";
import Issue2 from "../../../../organisms/student/ActiveLearningLessons/Lesson10/Issue2";
import styles from "../ActiveLearningLesson.module.scss";

export const Lesson10 = () => {
  const { state, dispatch } = React.useContext(Context);
  const [answers, setAnswers] = React.useState<IActiveLearningAnswers[]>([]);

  React.useEffect(() => {
    setAnswers([...state.active_learning_answers]);
  }, [state.active_learning_answers]);

  const currentActiveLearning = useMemo(() => {
    return state.active_learning_data_by_lesson;
  }, [state.active_learning_data_by_lesson]);

  const findIssue = useCallback(
    (no: number): IActiveLearningIssue | undefined =>
      currentActiveLearning.issues?.find(issue => issue.no === no),
    [currentActiveLearning.issues],
  );

  const saveAnswers = () => {
    const params = answers;
    const { material_code, no } = state.active_learning_data_by_lesson;
    dispatch(
      updateActiveLearningAnswers(material_code, no, JSON.stringify(params)),
    );
  };

  return (
    <>
      <div className={styles.wrapper} id="accordion">
        <Header
          no={currentActiveLearning.no}
          label={"描いたことを実現する"}
          title={currentActiveLearning.title}
          read={
            "自分が何を伝えたいのか、相手にどのように伝えたら伝わりやすいかを考えながら、課題解決のストーリーを発表しよう。"
          }
        />
        <div className={styles.container}>
          <div className={styles.section}>
            <Issue1
              issue={findIssue(1)}
              answers={answers}
              setAnswers={setAnswers}
            />
          </div>
          <div className={styles.saveAnswer}>
            <Button variant={"secondary"} handleClick={saveAnswers}>
              回答を保存する
            </Button>
          </div>
          <div className={styles.section}>
            <Issue2
              issue={findIssue(2)}
              answers={answers}
              setAnswers={setAnswers}
            />
          </div>
          <div className={styles.saveAnswer}>
            <Button variant={"secondary"} handleClick={saveAnswers}>
              回答を保存する
            </Button>
          </div>
          <div className={styles.section}>
            <EndLesson
              text={
                "次のLessonでは、今まで学んできた内容を振り返る。次回までに、学んだことや成長した点を整理しておこう。"
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Lesson10;
